import React from 'react';
import {Route, DefaultRoute} from 'react-router';

import Root from './handlers/Root';
import Portal from './handlers/Portal';

export default (
	<Route name="root" path="/" handler={Root}>
		<DefaultRoute name="home" handler={Portal} />
	</Route>
);



/** WEBPACK FOOTER **
 ** collegeboard/client/rawr/apps/cbportal/routes.jsx
 **/